// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"cfa4e58c","453":"470c3363","809":"449fda9e"}[chunkId] + ".chunk.js";
};